// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import { type APIPromise, APIResource, type FetchParams } from "../../core";

import type {
  ListPersonsResponseBody,
  Merchant,
  Person,
  Problem,
} from "../../types";
export type GetMerchantQueryParams = {
  version?: string;
};

export type ListPersonsQueryParams = {
  version?: string;
};

export type GetPersonQueryParams = {
  version?: string;
};

export class Merchants extends APIResource {
  /**
   * Retrieve a merchant.
   */
  get(
    merchantCode: string,
    query?: GetMerchantQueryParams,
    params?: FetchParams,
  ): APIPromise<Merchant, Problem> {
    return this._client.get<Merchant, Problem>({
      path: `/v1/merchants/${merchantCode}`,
      query,
      ...params,
    });
  }

  /**
   * Returns a list of persons related to the merchant.
   */
  listPersons(
    merchantCode: string,
    query?: ListPersonsQueryParams,
    params?: FetchParams,
  ): APIPromise<ListPersonsResponseBody, Problem> {
    return this._client.get<ListPersonsResponseBody, Problem>({
      path: `/v1/merchants/${merchantCode}/persons`,
      query,
      ...params,
    });
  }

  /**
   * Returns a single person related to the merchant.
   */
  getPerson(
    merchantCode: string,
    personId: string,
    query?: GetPersonQueryParams,
    params?: FetchParams,
  ): APIPromise<Person, Problem> {
    return this._client.get<Person, Problem>({
      path: `/v1/merchants/${merchantCode}/persons/${personId}`,
      query,
      ...params,
    });
  }
}
